import { AppFeatureTypes } from './AppFeatureTypes';

export const appFeatureDefaults: AppFeatureTypes = {
  auto_topup_tooltip_enabled: false,
  is_chart_broker_enabled: false,
};
